<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>UNESCO Sites</h1>

    <div>
      <div class='' id=''>
        <h3>National Park Durmitor</h3>
        <p class='pasus'>
          Durmitor is surely the most famous and the most spectacular national
          park in Montenegro. The region got protected by law and proclaimed
          national park as early as in 1952 to have its outstanding natural
          qualities recognized by UNESCO too in 1980.
        </p>
        <p class='pasus'>
          It covers the surface of around 32.500 hectares on the territories of
          five municipalities. The altitude of the park ranges from 500 m to
          2520 m above sea level. It is characterized by long and cold winters
          and relatively short and fresh summers.
        </p>
        <p class='pasus'>
          The park is a home to diverse ecosystems, some of the highest peaks of
          Dinarides (in total 48 peaks above 2000 m above sea level), 18 glacial
          lakes locally known as “mountain eyes”, deep canyons of Tara, Draga
          and Susica rivers. Tara Canyon was protected by UNESCO’s Man and the
          Biosphere Program and it’s one of the  deepest canyons on
          earth (1330 m) – harboring 1.500 different plants and 130 bird
          species.
        </p>
        <p class='pasus'>
          Durmitor massif is known for its aesthetic values, geomorphological
          features and deep canyons in addition to a wealth of flora and fauna,
          numerous endemic and relict species. The fauna is usually of
          mountainous and alpine type. Animals residing in the park include
          brown bear, wolf, chamois, roe deer, black grouse and golden eagle. Of
          1.325 plant species, 122 are endemic, 150 medicinal and 40 edible
          mushrooms.
        </p>
        <p class='pasus'>
          There are a number of cultural heritage sited in the park: churches
          and monasteries, mysterious medieval tombstones known as stećci which
          is only one of their many names, as well as a traditional architecture
          (houses, katuns, savardaks, mills…).
        </p>
        <p class='pasus'>
          Periodical shepherds’ settlements – katuns, located at higher
          altitudes which liven up only during the summer are the outstanding
          experience. It is where the best known Montenegro’s dairy products
          from sheep and cow milk are made.
        </p>
        <p class='pasus'>
          The park’s region is a true heaven for climbing, hiking, biking,
          canyoning and rafting enthusiasts as well as for ski and winter sports
          lovers in winter months.
        </p>
        <p class='pasus'>
          Staying in Zabljak, a mountainous town with an altitude of 1.450
          meters which makes it the highest situated town in the Balkans, near
          the spectacular Black Lake and enjoying the view on numerous Durmitor
          peaks is a unique feeling.
        </p>
      </div>
      <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>
      <div class='' id=''>
        <hr style="background-color:rgb(113, 186, 107);margin-top:10px;margin-bottom:10vh;"/>
        <h3>Natural and cultural-historical region of Kotor at UNESCO list</h3>
        <p class='pasus'>
          The best known locality in Montenegro listed as UNESCO world heritage
          site owing to its universal cultural-historical values and harmonious
          integrity with the surrounding landscape is certainly the region of
          Kotor municipality.
        </p>
        <p class='pasus'>
          It is among the first regions on earth (57) listed as the world
          cultural heritage in 1979.
        </p>
        <p class='pasus'>
          The region encompasses the best preserved part of Boka Bay surrounded
          by high slopes of Orjen and Lovcen mountains and covers the surface of
          14.600 hectares.
        </p>
        <p class='pasus'>
          The uniqueness of this cultural historical region is reflected in its
          architecture, palaces, monastery complexes, fortified cities,
          settlements and villages and their harmonious integration into the
          natural terraced landscape.
        </p>
        <p class='pasus'>
          The towns of Kotor, Perast and Risan and the settlements surrounding
          them have been important urban centers for centuries where different
          creative activities flourished.
        </p>
        <p class='pasus'>
          Boka Bay is often on the list of the most beautiful gulfs in the world
          and represents the southernmost European fjord. At the same time, it
          is a perfect natural harbor. Here the Adriatic Sea sets 15 miles
          inland creating the gulf made of four smaller bays surrounded by
          slopes and cliffs of high rocky hills.
        </p>
        <p class='pasus'>
          In a long history, the region had experienced a change of numerous
          state organizations and different civilizations and they all left
          important traces in its cultural heritage: Illyrians, Romans,
          Byzantines, Montenegrin and Serbian dynasties, Hungarians, French,
          Russians, Venetians…
        </p>
        <p class='pasus'>
          Today Kotor is one of the most visited destinations on Mediterranean,
          known as a cruising harbor, the town of numerous festivals and
          traditional celebrations, an art center and a powerful contributor to
          the overall development of the country and its image.
        </p>
      </div>
       <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='itemsKo'></vue-picture-swipe>
    </div>
      <div class='' id=''>
        <hr style="background-color:rgb(113, 186, 107);margin-top:10px;margin-bottom:10vh;"/>
        <h3>Stećci</h3>
        <h3>„Don't turn this stone over, don't interrupt my dream“</h3>
        <p class='pasus'>
          A phenomenon of European and world culture and definitely the most
          mysterious cultural-historical monuments in the Balkans are stećci
          which after a joint nomination by four countries (Bosnia and
          Herzegovina, Serbia, Croatia and Montenegro) became a part of UNESCO
          world cultural heritage in 2016.
        </p>
        <p class='pasus'>
          In Montenegro there are three sites included on a joint list enjoying
          the status of world cultural heritage.
        </p>
        <p class='pasus'>
          Stećci are unique monumental and monolithic stone tombstones densely
          spread in Bosnia and Herzegovina, southern Croatia, western Montenegro
          and south-western Serbia. Standing out in mountain plateaus and hills,
          alone or in groups, stećci represent a unique mark of medieval culture
          in the mentioned region. Very often stećci necropolises are situated
          on stunning viewpoints having completely integrated with nature thus
          making a unique environmental complex.
        </p>
        <p class='pasus'>
          The culture of stećci belongs to the period from the 12th to the 16th
          century whereby its occurrence, the overall features and the region it
          emerges do not follow any direct historical pattern. It is the
          unusual, impressive, mysterious and insufficiently elaborated cultural
          occurrence so it can be claimed that stećci represent a distinctive
          and unique phenomenon in both European and global culture.
        </p>
        <p class='pasus'>
          <i
            >The greatest dilemmas concern their origin, the affiliation of the
            deceased buried under stećci as well as the symbolism of messages
            carried by images carved into stones. Most data for historians are
            provided by inscriptions featuring a lesser number of stećci
            revealing different social statuses of those buried under the
            stones.</i
          >
        </p>
        <p class='pasus'>
          <i
            >The diversity and beauty of decorative motifs on stećci and most of
            all their mysteriousness attracted many experts who explored them.
            Stećci are true medieval pictures in stone, with relief depicting
            religious motifs, human characters, animals, plant ornaments, antic
            and solar symbols. Relief motifs are testimony to the influence of
            Roman and Gothic artistic circles but also to Slovene mythology and
            ancient antic heritage.</i
          >
        </p>
        <p class='pasus'>
          <i
            >Experienced stonemasons embellished stećak with both text and
            paintings, never randomly and without order. Every picture, every
            chisel blow had its goal – to portray words, deeds and lives of the
            deceased.</i
          >
        </p>
      </div>
      <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='itemsSt'></vue-picture-swipe>
    </div>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe'
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/placestogo/06/01.jpg'),
          thumbnail: require('@/assets/placestogo/06/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/02.jpg'),
          thumbnail: require('@/assets/placestogo/06/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/03.jpg'),
          thumbnail: require('@/assets/placestogo/06/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/04.jpg'),
          thumbnail: require('@/assets/placestogo/06/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/05.jpg'),
          thumbnail: require('@/assets/placestogo/06/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/06.jpg'),
          thumbnail: require('@/assets/placestogo/06/06.jpg'),
          w: 0,
          h: 720
        }
      ],
      itemsKo: [
        {
          src: require('@/assets/placestogo/06/01ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/01ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/02ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/02ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/03ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/03ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/04.jpg'),
          thumbnail: require('@/assets/placestogo/06/04ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/05ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/05ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/06ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/06ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/07ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/07ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/08ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/08ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/09ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/09ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/10ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/10ko.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/11ko.jpg'),
          thumbnail: require('@/assets/placestogo/06/11ko.jpg'),
          w: 0,
          h: 720
        }
      ],
      itemsSt: [
        {
          src: require('@/assets/placestogo/06/01st.jpg'),
          thumbnail: require('@/assets/placestogo/06/01st.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/02st.jpg'),
          thumbnail: require('@/assets/placestogo/06/02st.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/06/03st.jpg'),
          thumbnail: require('@/assets/placestogo/06/03st.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/PTG6_UnescoSites.vue